import { render, staticRenderFns } from "./WorkbookDetails.vue?vue&type=template&id=2fb9bfde"
import script from "./WorkbookDetails.vue?vue&type=script&lang=js"
export * from "./WorkbookDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports